import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { reviews, shop } from "../../data";

function Stars({ n }) {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={15}
          className={
            i < n
              ? "fill-[#C24E77] text-[#C24E77]"
              : "fill-transparent text-[#C24E77]/30"
          }
          aria-hidden="true"
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section
      id="recensioni"
      data-testid="reviews-section"
      className="py-24 md:py-32 scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-xl">
            <div className="text-xs tracking-[0.2em] uppercase text-[#C24E77] mb-6">
              Dicono di noi
            </div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#123D5B] leading-tight">
              Le parole delle
              <span className="italic text-[#C24E77]"> nostre clienti.</span>
            </h2>
          </div>
          <div className="glass border border-[#123D5B]/8 rounded-2xl px-8 py-6 flex items-center gap-5">
            <span className="font-serif text-5xl text-[#C24E77] leading-none">
              {shop.rating}
            </span>
            <div>
              <Stars n={4} />
              <p className="text-sm text-[#4A5863] mt-1">
                {shop.reviewsCount} recensioni su Google
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className="relative bg-white border border-[#123D5B]/8 rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(18,61,91,0.12)]"
            >
              <Quote
                className="text-[#C24E77]/20 mb-4"
                size={32}
                aria-hidden="true"
              />
              <p className="text-[#4A5863] leading-relaxed text-[15px]">
                {r.text}
              </p>
              <div className="mt-6 pt-5 border-t border-[#123D5B]/8 flex items-center justify-between">
                <span className="font-500 text-[#123D5B]">{r.name}</span>
                <Stars n={r.stars} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
